import { NewProduct } from '@/types/api/api-v4/product'
import { Factoid } from '@/types/main'

export interface Slider {
  factoid: Factoid
  link: SliderLink
  name: string
  products: NewProduct[]
  type: SliderType
}

export type SliderLink = {
  title: string
  path: string
}

export enum SliderType {
  SALE = 'sale',
  SIMPLE = 'simple',
  POPULAR = 'popular',
}

export interface Sliders {
  saleSlider: Slider[]
  sliders: Slider[]
  popularSlider: Slider[]
}
